export const { getMacroById } = require('./macroArticleQueriesGraphQL');
